import { createEntityComponent } from "@coltorapps/builder-react";

import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

import { expressionFieldEntity } from "./definition";

export const ExpressionFieldEntity = createEntityComponent(
  expressionFieldEntity,
  function ExpressionFieldEntity(props) {
    const id = props.entity.attributes.name || props.entity.id;
    const label =
      props.entity.attributes.label.value || props.entity.attributes.name;
    const displayValue =
      props.entity.value === undefined || props.entity.value === null
        ? ""
        : String(props.entity.value);

    return (
      <div className="w-full">
        <Label htmlFor={id}>{label}</Label>
        <Input id={id} name={id} value={displayValue} disabled readOnly />
      </div>
    );
  },
);
